/* JS for main-product, featured-product, product-item, shop-the-look */
(function() {
  const init = function() {
    const triggerEvent = (element, eventName, detail = {}) => {
      if (!element) {
        return;
      }
      element.dispatchEvent(new CustomEvent(eventName, {
        bubbles: true,
        detail
      }));
    };
    // js/helper/product-loader.js
    var ProductLoader = class {
      static load(productHandle) {
        if (!productHandle) {
          return;
        }
        if (this.loadedProducts[productHandle]) {
          return this.loadedProducts[productHandle];
        }
        this.loadedProducts[productHandle] = new Promise(async (resolve) => {
          const response = await fetch(`${window.themeVariables.routes.rootUrlWithoutSlash}/products/${productHandle}.js`);
          const responseAsJson = await response.json();
          resolve(responseAsJson);
        });
        return this.loadedProducts[productHandle];
      }
    };
    window.__publicField(ProductLoader, "loadedProducts", {});
    
    // js/custom-element/section/product/image-zoom.js
    if (!window.customElements.get("product-image-zoom")) {
      var PhotoSwipeUi = class {
        constructor(pswp) {
          this.photoSwipeInstance = pswp;
          this.delegate = new main_default(this.photoSwipeInstance.scrollWrap);
          this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2;
          this.pswpUi = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__ui");
          this.delegate.on("click", '[data-action="pswp-close"]', this._close.bind(this));
          this.delegate.on("click", '[data-action="pswp-prev"]', this._goToPrev.bind(this));
          this.delegate.on("click", '[data-action="pswp-next"]', this._goToNext.bind(this));
          this.delegate.on("click", '[data-action="pswp-move-to"]', this._moveTo.bind(this));
          this.photoSwipeInstance.listen("close", this._onPswpClosed.bind(this));
          this.photoSwipeInstance.listen("doubleTap", this._onPswpDoubleTap.bind(this));
          this.photoSwipeInstance.listen("beforeChange", this._onPswpBeforeChange.bind(this));
          this.photoSwipeInstance.listen("initialZoomInEnd", this._onPswpInitialZoomInEnd.bind(this));
          this.photoSwipeInstance.listen("initialZoomOut", this._onPswpInitialZoomOut.bind(this));
          this.photoSwipeInstance.listen("parseVerticalMargin", this._onPswpParseVerticalMargin.bind(this));
          this.delegate.on("pswpTap", ".pswp__img", this._onPswpTap.bind(this));
        }
        init() {
          const prevNextButtons = this.pswpUi.querySelector(".pswp__prev-next-buttons"), dotsNavWrapper = this.pswpUi.querySelector(".pswp__dots-nav-wrapper");
          if (this.photoSwipeInstance.items.length <= 1) {
            prevNextButtons.style.display = "none";
            dotsNavWrapper.style.display = "none";
            return;
          }
          prevNextButtons.style.display = "";
          dotsNavWrapper.style.display = "";
          let dotsNavHtml = "";
          this.photoSwipeInstance.items.forEach((item, index) => {
            dotsNavHtml += `
              <button class="dots-nav__item tap-area" ${index === 0 ? 'aria-current="true"' : ""} data-action="pswp-move-to">
                <span class="visually-hidden">Go to slide ${index}</span>
              </button>
            `;
          });
          dotsNavWrapper.querySelector(".pswp__dots-nav-wrapper .dots-nav").innerHTML = dotsNavHtml;
        }
        _close() {
          this.photoSwipeInstance.close();
        }
        _goToPrev() {
          this.photoSwipeInstance.prev();
        }
        _goToNext() {
          this.photoSwipeInstance.next();
        }
        _moveTo(event, target) {
          this.photoSwipeInstance.goTo([...target.parentNode.children].indexOf(target));
        }
        _onPswpClosed() {
          this.delegate.off("pswpTap");
        }
        _onPswpDoubleTap(point) {
          const initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;
          if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
            this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
          } else {
            this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : this.maxSpreadZoom, point, 333);
          }
        }
        _onPswpTap(event) {
          if (event.detail.pointerType === "mouse") {
            this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
          }
        }
        _onPswpBeforeChange() {
          if (this.photoSwipeInstance.items.length <= 1) {
            return;
          }
          const dots = this.photoSwipeInstance.scrollWrap.querySelectorAll(".dots-nav__item");
          const activeDot = this.photoSwipeInstance.scrollWrap.querySelector(`.dots-nav__item:nth-child(${this.photoSwipeInstance.getCurrentIndex() + 1})`);
          dots.forEach((item) => item.removeAttribute("aria-current"));
          activeDot.setAttribute("aria-current", "true");
        }
        _onPswpInitialZoomInEnd() {
          var _a;
          (_a = this.pswpUi) == null ? void 0 : _a.classList.remove("pswp__ui--hidden");
        }
        _onPswpInitialZoomOut() {
          var _a;
          (_a = this.pswpUi) == null ? void 0 : _a.classList.add("pswp__ui--hidden");
        }
        _onPswpParseVerticalMargin(item) {
          item.vGap.bottom = this.photoSwipeInstance.items.length <= 1 || window.matchMedia(window.themeVariables.breakpoints.lapAndUp).matches ? 0 : 60;
        }
      };
      const OpenableElement = window.customElements.get("openable-element");
      var ProductImageZoom = class extends OpenableElement {
        connectedCallback() {
          super.connectedCallback();
          this.mediaElement = this.closest(".product__media");
          this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2;
          window.LibraryLoader.load("photoswipe");
        }
        disconnectedCallback() {
          var _a;
          super.disconnectedCallback();
          (_a = this.photoSwipeInstance) == null ? void 0 : _a.destroy();
        }
        async attributeChangedCallback(name, oldValue, newValue) {
          super.attributeChangedCallback(name, oldValue, newValue);
          switch (name) {
            case "open":
              if (this.open) {
                await window.LibraryLoader.load("photoswipe");
                this._openPhotoSwipe();
              }
          }
        }
        async _openPhotoSwipe() {
          const items = await this._buildItems();
          this.photoSwipeInstance = new window.ThemePhotoSwipe(this, PhotoSwipeUi, items, {
            index: items.findIndex((item) => item.selected),
            maxSpreadZoom: this.maxSpreadZoom,
            loop: false,
            allowPanToNext: false,
            closeOnScroll: false,
            closeOnVerticalDrag: window.matchMedia("(pointer: fine)").matches,
            showHideOpacity: true,
            arrowKeys: true,
            history: false,
            getThumbBoundsFn: () => {
              const thumbnail = this.mediaElement.querySelector(".product__media-item:not([hidden])"), pageYScroll = window.pageYOffset || document.documentElement.scrollTop, rect = thumbnail.getBoundingClientRect();
              return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
            },
            getDoubleTapZoom: (isMouseClick, item) => {
              if (isMouseClick) {
                return item.w > item.h ? 1.6 : 1;
              } else {
                return item.initialZoomLevel < 0.7 ? 1 : 1.33;
              }
            }
          });
          let lastWidth = null;
          this.photoSwipeInstance.updateSize = new Proxy(this.photoSwipeInstance.updateSize, {
            apply: (target, thisArg, argArray) => {
              if (lastWidth !== window.innerWidth) {
                target(arguments);
                lastWidth = window.innerWidth;
              }
            }
          });
          this.photoSwipeInstance.listen("close", () => {
            this.open = false;
          });
          this.photoSwipeInstance.init();
        }
        async _buildItems() {
          const activeImages = Array.from(this.mediaElement.querySelectorAll('.product__media-item[data-media-type="image"]:not(.is-filtered)')), product = await ProductLoader.load(this.getAttribute("product-handle"));
          return Promise.resolve(activeImages.map((item) => {
            const matchedMedia = product["media"].find((media) => media.id === parseInt(item.getAttribute("data-media-id"))), supportedSizes = window.getSupportedSizes(matchedMedia, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800, 2e3, 2200, 2400, 2600, 2800, 3e3]), desiredWidth = Math.min(supportedSizes[supportedSizes.length - 1], window.innerWidth);
            return {
              selected: item.hasAttribute("hidden"),
              src: window.getSizedMediaUrl(matchedMedia, `${Math.ceil(Math.min(desiredWidth * window.devicePixelRatio * this.maxSpreadZoom, 3e3))}x`),
              msrc: item.firstElementChild.currentSrc,
              originalMedia: matchedMedia,
              w: desiredWidth,
              h: parseInt(desiredWidth / matchedMedia["aspect_ratio"])
            };
          }));
        }
      };
      window.customElements.define("product-image-zoom", ProductImageZoom);
    }
    
    // js/custom-element/section/product/inventory.js
    if (!window.customElements.get("product-inventory")) {
      var ProductInventory = class extends HTMLElement {
        connectedCallback() {
          var _a;
          const scriptTag = this.querySelector("script");
          if (!scriptTag) {
            return;
          }
          this.inventories = JSON.parse(scriptTag.innerHTML);
          (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this));
        }
        _onVariantChanged(event) {
          var _a;
          (_a = this.querySelector("span")) == null ? void 0 : _a.remove();
          if (event.detail.variant && this.inventories[event.detail.variant["id"]] !== "") {
            this.hidden = false;
            this.insertAdjacentHTML("afterbegin", this.inventories[event.detail.variant["id"]]);
          } else {
            this.hidden = true;
          }
        }
      };
      window.customElements.define("product-inventory", ProductInventory);
    }
    
    // js/custom-element/section/product/payment-container.js
    if (!window.customElements.get("product-payment-container")) {
      var PaymentContainer = class extends HTMLElement {
        connectedCallback() {
          var _a;
          (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this));
          if (Shopify.designMode && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        }
        _onVariantChanged(event) {
          this._updateAddToCartButton(event.detail.variant);
          this._updateDynamicCheckoutButton(event.detail.variant);
        }
        _updateAddToCartButton(variant) {
          let addToCartButtonElement = this.querySelector("[data-product-add-to-cart-button]");
          if (!addToCartButtonElement) {
            return;
          }
          let addToCartButtonText = "";
          addToCartButtonElement.classList.remove("button--primary", "button--secondary", "button--ternary");
          if (!variant) {
            addToCartButtonElement.setAttribute("disabled", "disabled");
            addToCartButtonElement.classList.add("button--ternary");
            addToCartButtonText = window.themeVariables.strings.productFormUnavailable;
          } else {
            if (variant["available"]) {
              addToCartButtonElement.removeAttribute("disabled");
              addToCartButtonElement.classList.add(addToCartButtonElement.hasAttribute("data-use-primary") ? "button--primary" : "button--secondary");
              addToCartButtonText = addToCartButtonElement.getAttribute("data-button-content");
            } else {
              addToCartButtonElement.setAttribute("disabled", "disabled");
              addToCartButtonElement.classList.add("button--ternary");
              addToCartButtonText = window.themeVariables.strings.productFormSoldOut;
            }
          }
          if (addToCartButtonElement.getAttribute("is") === "loader-button") {
            addToCartButtonElement.firstElementChild.innerHTML = addToCartButtonText;
          } else {
            addToCartButtonElement.innerHTML = addToCartButtonText;
          }
        }
        _updateDynamicCheckoutButton(variant) {
          let paymentButtonElement = this.querySelector(".shopify-payment-button");
          if (!paymentButtonElement) {
            return;
          }
          paymentButtonElement.style.display = !variant || !variant["available"] ? "none" : "block";
        }
      };
      window.customElements.define("product-payment-container", PaymentContainer);
    }
    
    // js/custom-element/section/product/payment-terms.js
    if (!window.customElements.get("product-payment-terms")) {
      var PaymentTerms = class extends CustomHTMLElement {
        connectedCallback() {
          var _a;
          (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this));
        }
        _onVariantChanged(event) {
          const variant = event.detail.variant;
          if (variant) {
            const idElement = this.querySelector('[name="id"]');
            idElement.value = variant["id"];
            idElement.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      };
      window.customElements.define("product-payment-terms", PaymentTerms);
    }
    
    // js/custom-element/section/product/product-form.js
    if (!window.customElements.get("product-form")) {
      var ProductForm = class extends HTMLFormElement {
        connectedCallback() {
          this.id.disabled = false;
          if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
            return;
          }
          this.addEventListener("submit", this._onSubmit.bind(this));
        }
        async _onSubmit(event) {
          event.preventDefault();
          if (!this.checkValidity()) {
            this.reportValidity();
            return;
          }
          const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
          submitButtons.forEach((submitButton) => {
            submitButton.setAttribute("disabled", "disabled");
            submitButton.setAttribute("aria-busy", "true");
          });
          const productForm = new FormData(this);
          productForm.append("sections", ["mini-cart"]);
          productForm.delete("option1");
          productForm.delete("option2");
          productForm.delete("option3");
          const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
            body: productForm,
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest"
            }
          });
          submitButtons.forEach((submitButton) => {
            submitButton.removeAttribute("disabled");
            submitButton.removeAttribute("aria-busy");
          });
          const responseJson = await response.json();
          if (response.ok) {
            const variant = responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson;
            this.dispatchEvent(new CustomEvent("variant:added", {
              bubbles: true,
              detail: {
                variant: variant,
                quantity: parseInt(productForm.get("quantity"))
              }
            }));
            this.sendAddToCartEvent(variant, parseInt(productForm.get("quantity")));
            fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
              const cartContent = await response2.json();
              document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                bubbles: true,
                detail: {
                  cart: cartContent
                }
              }));
              cartContent["sections"] = responseJson["sections"];
              document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                  cart: cartContent,
                  openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
                }
              }));
            });
          }
          this.dispatchEvent(new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: {
              status: response.ok ? "success" : "error",
              error: responseJson["description"] || ""
            }
          }));
        }
        sendAddToCartEvent(variant, quantity) {
          const eventData = {
            event: 'dl_add_to_cart',
            ecommerce: {
              currencyCode: 'EUR',
              add: {
                products: [{
                  id: variant.sku,
                  name: variant.product_title,
                  brand: variant.vendor,
                  category: variant.product_type,
                  variant: variant.title,
                  price: (parseFloat(variant.price) / 100).toFixed(2),
                  quantity: quantity,
                  product_id: variant.product_id,
                  variant_id: variant.variant_id,
                  compare_at_price: (parseFloat(variant.original_price) / 100).toFixed(2),
                  image: variant.image,
                  dimension1: window.customGtmProductInformation.product.productLinie,
                  dimension3: window.customGtmProductInformation.product.itemCategory,
                  dimension6: window.customGtmProductInformation.product.engraveService,
                  dimension10: window.customGtmProductInformation.product.collections,
                  dimension11: window.customGtmProductInformation.product.referrerCategory,
                }]
              }
            }
          };

          window.pushEventWithConsent(eventData);
        }
      };
      window.customElements.define("product-form", ProductForm, { extends: "form" });
    }
    
    // js/custom-element/section/product/product-media.js
    if (!window.customElements.get("product-media")) {
      var ProductMedia = class extends CustomHTMLElement {
        async connectedCallback() {
          var _a;
          this.mainCarousel = this.querySelector("native-carousel");
          if (this.hasAttribute("reveal-on-scroll")) {
            this._setupVisibility();
          }
          if (this.mainCarousel.items === 1) {
            return;
          }
          this.selectedVariantMediaId = null;
          this.viewInSpaceElement = this.querySelector("[data-shopify-model3d-id]");
          this.zoomButton = this.querySelector(".product__zoom-button");
          this.prevNextOverlay = this.querySelector(".product-media-prev-next--overlay");
          this.product = await ProductLoader.load(this.getAttribute("product-handle"));
          (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this));

          if (this.viewInSpaceElement) {
            this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", this.viewInSpaceElement.getAttribute("data-shopify-model3d-default-id"));
          }
          this.mainCarousel.addEventListener("slide-changed", this._handleSlideChanged.bind(this));
          window.addEventListener("pplrAppInitiated", function() {
            this._handleSlideChanged({detail: {current: this.mainCarousel.selectedIndex}});
          }.bind(this));
          this._handleSlideChanged({detail: {current: this.mainCarousel.selectedIndex}});
        }
        get thumbnailsPosition() {
          return window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? "bottom" : this.getAttribute("thumbnails-position");
        }
        async _setupVisibility() {
          await this.untilVisible();
          const image = this.mainCarousel ? this.mainCarousel.items[this.mainCarousel.selectedIndex].querySelector("img") : this.querySelector(".product__media-image-wrapper img"), prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          await window.imageLoaded(image);
          const animation = new window.CustomAnimation(new window.ParallelEffect([
            new window.CustomKeyframeEffect(image, { opacity: [0, 1], transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"] }, { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }),
            new window.ParallelEffect(Array.from(this.querySelectorAll(".product__thumbnail-item:not(.is-filtered)")).map((item, index) => {
              return new window.CustomKeyframeEffect(item, {
                opacity: [0, 1],
                transform: this.thumbnailsPosition === "left" ? [`translateY(${prefersReducedMotion ? 0 : "40px"})`, "translateY(0)"] : [`translateX(${prefersReducedMotion ? 0 : "50px"})`, "translateX(0)"]
              }, {
                duration: 250,
                delay: prefersReducedMotion ? 0 : 100 * index,
                easing: "cubic-bezier(0.75, 0, 0.175, 1)"
              });
            }))
          ]));
          this._hasSectionReloaded ? animation.finish() : animation.play();
        }
        async _onVariantChanged(event) {
          const variant = event.detail.variant;
          const filteredMediaIds = [];
          this.product["media"].forEach((media) => {
            var _a;
            let matchMedia2 = variant["featured_media"] && media["id"] === variant["featured_media"]["id"];
            if ((_a = media["alt"]) == null ? void 0 : _a.includes("#")) {
              if (!matchMedia2) {
                const altParts = media["alt"].split("#"), mediaGroupParts = altParts.pop().split("_");
                this.product["options"].forEach((option) => {
                  if (option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()) {
                    if (variant["options"][option["position"] - 1].toLowerCase() !== mediaGroupParts[1].trim().toLowerCase()) {
                      filteredMediaIds.push(media["id"]);
                    }
                  }
                });
              }
            }
          });
          const currentlyFilteredIds = [...new Set(Array.from(this.querySelectorAll(".is-filtered[data-media-id]")).map((item) => parseInt(item.getAttribute("data-media-id"))))];
          if (currentlyFilteredIds.some((value) => !filteredMediaIds.includes(value))) {
            const selectedMediaId = variant["featured_media"] ? variant["featured_media"]["id"] : this.product["media"].map((item) => item.id).filter((item) => !filteredMediaIds.includes(item))[0];
            Array.from(this.querySelectorAll("[data-media-id]")).forEach((item) => {
              item.classList.toggle("is-filtered", filteredMediaIds.includes(parseInt(item.getAttribute("data-media-id"))));
              item.classList.toggle("is-selected", selectedMediaId === parseInt(item.getAttribute("data-media-id")));
              item.classList.toggle("is-initial-selected", selectedMediaId === parseInt(item.getAttribute("data-media-id")));
            });
            this.mainCarousel.reload();
          } else {
            if (!event.detail.variant["featured_media"] || this.selectedVariantMediaId === event.detail.variant["featured_media"]["id"]) {
              return;
            }
            this.mainCarousel.select(`[data-media-id="${event.detail.variant["featured_media"]["id"]}"]`);
          }
          this.selectedVariantMediaId = event.detail.variant["featured_media"] ? event.detail.variant["featured_media"]["id"] : null;
        }

        _handleSlideChanged(ev) {
          const previous = ev.detail.previous, current = ev.detail.current; 
          if (typeof previous != "undefined" && ["external_video", "video", "model"].includes(this.mainCarousel.items[previous].getAttribute("data-media-type"))) {
            this.mainCarousel.items[previous].querySelector(".video-wrapper")?.pause();
          }
          if (typeof current != "undefined") {
            switch (this.mainCarousel.items[current].getAttribute("data-media-type")) {
              case "model":
                this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", this.mainCarousel.items[current].getAttribute("data-media-id"));
                this.mainCarousel.items[current].querySelector(".video-wrapper")?.play();
                break;
              case "external_video":
              case "video":
                if (this.hasAttribute("autoplay-video")) {
                  this.mainCarousel.items[current].querySelector(".video-wrapper")?.play();
                }
                break;
            }
            const isImage = this.mainCarousel.items[current].getAttribute("data-media-type") == "image";
            const hasPreview = this.mainCarousel.items[current].querySelector(".pplr");
            if(this.zoomButton) {
              this.zoomButton.hidden = !isImage;
            }
            this.mainCarousel.dragEnabled = isImage;
            if(this.prevNextOverlay) {
              this.prevNextOverlay.toggleAttribute("hidden", !isImage || hasPreview);
            }
            const aspectRatio = this.mainCarousel.items[current].clientHeight / this.mainCarousel.items[current].clientWidth;
            const mediaList = this.querySelector(".product__media-list");
            if(mediaList) {
              mediaList.style["padding-bottom"] = `${aspectRatio * 100}%`;
            }
          }
        }

        _updateControlsVisibility(state) {
          this.mainCarousel.dragEnabled = state;
          if(this.prevNextOverlay) {
            this.prevNextOverlay.toggleAttribute("hidden", !state);
          }
        }
      };
      window.customElements.define("product-media", ProductMedia);
    }
    
    // js/custom-element/section/product/product-meta.js
    if (!window.customElements.get("product-meta")) {
      var ProductMeta = class extends HTMLElement {
        connectedCallback() {
          var _a;
          (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this));
        }
        get priceClass() {
          return this.getAttribute("price-class") || "";
        }
        get unitPriceClass() {
          return this.getAttribute("unit-price-class") || "";
        }
        _onVariantChanged(event) {
          this._updateLabels(event.detail.variant);
          this._updatePrices(event.detail.variant);
          this._updateSku(event.detail.variant);
        }
        _updateLabels(variant) {
          let productLabelList = this.querySelector("[data-product-label-list]");
          if (!productLabelList) {
            return;
          }
          if (!variant) {
            productLabelList.innerHTML = "";
          } else {
            productLabelList.innerHTML = "";
            if (!variant["available"]) {
              productLabelList.innerHTML = `<span class="label label--subdued">${window.themeVariables.strings.collectionSoldOut}</span>`;
            } else if (variant["compare_at_price"] > variant["price"]) {
              let savings = "";
              if (window.themeVariables.settings.discountMode === "percentage") {
                savings = `${Math.round((variant["compare_at_price"] - variant["price"]) * 100 / variant["compare_at_price"])}%`;
              } else {
                savings = window.formatMoney(variant["compare_at_price"] - variant["price"]);
              }
              productLabelList.innerHTML = `<span class="label label--highlight">${window.themeVariables.strings.collectionDiscount.replace("@savings@", savings)}</span>`;
            }
          }
        }
        _updatePrices(variant) {
          let productPrices = this.querySelector("[data-product-price-list]"), currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
          if (!productPrices) {
            return;
          }
          if (!variant) {
            productPrices.style.display = "none";
          } else {
            productPrices.innerHTML = "";
            if (variant["compare_at_price"] > variant["price"]) {
              productPrices.innerHTML += `<span class="price price--highlight ${this.priceClass}"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${window.formatMoney(variant["price"], currencyFormat)}</span>`;
              productPrices.innerHTML += `<span class="price price--compare"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${window.formatMoney(variant["compare_at_price"], currencyFormat)}</span>`;
            } else {
              productPrices.innerHTML += `<span class="price ${this.priceClass}"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${window.formatMoney(variant["price"], currencyFormat)}</span>`;
            }
            if (variant["unit_price_measurement"]) {
              let referenceValue = "";
              if (variant["unit_price_measurement"]["reference_value"] !== 1) {
                referenceValue = `<span class="unit-price-measurement__reference-value">${variant["unit_price_measurement"]["reference_value"]}</span>`;
              }
              productPrices.innerHTML += `
                <div class="price text--subdued ${this.unitPriceClass}">
                  <div class="unit-price-measurement">
                    <span class="unit-price-measurement__price">${window.formatMoney(variant["unit_price"])}</span>
                    <span class="unit-price-measurement__separator">/</span>
                    ${referenceValue}
                    <span class="unit-price-measurement__reference-unit">${variant["unit_price_measurement"]["reference_unit"]}</span>
                  </div>
                </div>
              `;
            }
            productPrices.style.display = "";
          }
        }
        _updateSku(variant) {
          let productSku = this.querySelector("[data-product-sku-container]");
          if (!productSku) {
            return;
          }
          let productSkuNumber = productSku.querySelector("[data-product-sku-number]");
          if (!variant || !variant["sku"]) {
            productSku.style.display = "none";
          } else {
            productSkuNumber.innerHTML = variant["sku"];
            productSku.style.display = "";
          }
        }
      };
      window.customElements.define("product-meta", ProductMeta);
    }
    
    // js/custom-element/section/product-list/quick-buy-drawer.js
    if (!window.customElements.get("quick-buy-drawer")) {
      const DrawerContent = window.customElements.get("drawer-content");
      var QuickBuyDrawer = class extends DrawerContent {
        connectedCallback() {
          super.connectedCallback();
          this.delegate.on("variant:changed", this._onVariantChanged.bind(this));
        }
        async _load() {
          await super._load();
          this.imageElement = this.querySelector(".quick-buy-product__image");
          if (window.Shopify && window.Shopify.PaymentButton) {
            window.Shopify.PaymentButton.init();
          }
        }
        _onVariantChanged(event) {
          const variant = event.detail.variant;
          if (variant) {
            Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
              const url = new URL(link.href);
              url.searchParams.set("variant", variant["id"]);
              link.setAttribute("href", url.toString());
            });
          }
          if (!this.imageElement || !variant || !variant["featured_media"]) {
            return;
          }
          const featuredMedia = variant["featured_media"];
          if (featuredMedia["alt"]) {
            this.imageElement.setAttribute("alt", featuredMedia["alt"]);
          }
          this.imageElement.setAttribute("width", featuredMedia["preview_image"]["width"]);
          this.imageElement.setAttribute("height", featuredMedia["preview_image"]["height"]);
          this.imageElement.setAttribute("src", window.getSizedMediaUrl(featuredMedia, "342x"));
          this.imageElement.setAttribute("srcset", window.getMediaSrcset(featuredMedia, [114, 228, 342]));
        }
      };
      window.customElements.define("quick-buy-drawer", QuickBuyDrawer);
    }
    
    // js/custom-element/section/product-list/quick-buy-popover.js
    if (!window.customElements.get("quick-buy-popover")) {
      const PopoverContent = window.customElements.get("popover-content");
      var QuickBuyPopover = class extends PopoverContent {
        connectedCallback() {
          super.connectedCallback();
          this.delegate.on("variant:changed", this._onVariantChanged.bind(this));
          this.delegate.on("variant:added", () => this.open = false);
        }
        async _load() {
          await super._load();
          this.imageElement = this.querySelector(".quick-buy-product__image");
        }
        _onVariantChanged(event) {
          const variant = event.detail.variant;
          if (variant) {
            Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
              const url = new URL(link.href);
              url.searchParams.set("variant", variant["id"]);
              link.setAttribute("href", url.toString());
            });
          }
          if (!this.imageElement || !variant || !variant["featured_media"]) {
            return;
          }
          const featuredMedia = variant["featured_media"];
          if (featuredMedia["alt"]) {
            this.imageElement.setAttribute("alt", featuredMedia["alt"]);
          }
          this.imageElement.setAttribute("width", featuredMedia["preview_image"]["width"]);
          this.imageElement.setAttribute("height", featuredMedia["preview_image"]["height"]);
          this.imageElement.setAttribute("src", window.getSizedMediaUrl(featuredMedia, "195x"));
          this.imageElement.setAttribute("srcset", window.getMediaSrcset(featuredMedia, [65, 130, 195]));
        }
      };
      window.customElements.define("quick-buy-popover", QuickBuyPopover);
    }
    
    // js/custom-element/section/product/variants.js
    if (!window.customElements.get("product-variants")) {
      var ProductVariants = class extends CustomHTMLElement {
        async connectedCallback() {
          this.masterSelector = document.getElementById(this.getAttribute("form-id")).id;
          this.optionSelectors = Array.from(this.querySelectorAll("[data-selector-type]"));
          if (!this.masterSelector) {
            console.warn(`The variant selector for product with handle ${this.productHandle} is not linked to any product form.`);
            return;
          }
          this.product = await ProductLoader.load(this.productHandle);
          this.delegate.on("change", '[name^="option"]', this._onOptionChanged.bind(this));
          this.masterSelector.addEventListener("change", this._onMasterSelectorChanged.bind(this));
          this._updateDisableSelectors();
          this.selectVariant(this.selectedVariant["id"]);
        }
        get selectedVariant() {
          return this._getVariantById(parseInt(this.masterSelector.value));
        }
        get productHandle() {
          return this.getAttribute("handle");
        }
        get hideSoldOutVariants() {
          return this.hasAttribute("hide-sold-out-variants");
        }
        get updateUrl() {
          return this.hasAttribute("update-url");
        }
        selectVariant(id) {
          var _a;
          if (!this._isVariantSelectable(this._getVariantById(id))) {
            id = this._getFirstMatchingAvailableOrSelectableVariant()["id"];
          }
          if (((_a = this.selectedVariant) == null ? void 0 : _a.id) === id) {
            return;
          }
          this.masterSelector.value = id;
          this.masterSelector.dispatchEvent(new Event("change", { bubbles: true }));
          if (this.updateUrl && history.replaceState) {
            const newUrl = new URL(window.location.href);
            if (id) {
              newUrl.searchParams.set("variant", id);
            } else {
              newUrl.searchParams.delete("variant");
            }
            window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
          }
          this._updateDisableSelectors();
          triggerEvent(this.masterSelector.form, "variant:changed", { variant: this.selectedVariant });
        }
        _onOptionChanged() {
          var _a;
          this.selectVariant((_a = this._getVariantFromOptions()) == null ? void 0 : _a.id);
        }
        _onMasterSelectorChanged() {
          var _a;
          const options = ((_a = this.selectedVariant) == null ? void 0 : _a.options) || [];
          options.forEach((value, index) => {
            let input = this.querySelector(`input[name="option${index + 1}"][value="${CSS.escape(value)}"], select[name="option${index + 1}"]`), triggerChangeEvent = false;
            if (input.tagName === "SELECT") {
              triggerChangeEvent = input.value !== value;
              input.value = value;
            } else if (input.tagName === "INPUT") {
              triggerChangeEvent = !input.checked && input.value === value;
              input.checked = input.value === value;
            }
            if (triggerChangeEvent) {
              input.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });
        }
        _getVariantById(id) {
          return this.product["variants"].find((variant) => variant["id"] === id);
        }
        _getVariantFromOptions() {
          const options = this._getSelectedOptionValues();
          return this.product["variants"].find((variant) => {
            return variant["options"].every((value, index) => value === options[index]);
          });
        }
        _isVariantSelectable(variant) {
          if (!variant) {
            return false;
          } else {
            return variant["available"] || !this.hideSoldOutVariants && !variant["available"];
          }
        }
        _getFirstMatchingAvailableOrSelectableVariant() {
          let options = this._getSelectedOptionValues(), matchedVariant = null, slicedCount = 0;
          do {
            options.pop();
            slicedCount += 1;
            matchedVariant = this.product["variants"].find((variant) => {
              if (this.hideSoldOutVariants) {
                return variant["available"] && variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
              } else {
                return variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
              }
            });
          } while (!matchedVariant && options.length > 0);
          return matchedVariant;
        }
        _getSelectedOptionValues() {
          const options = [];
          Array.from(this.querySelectorAll('input[name^="option"]:checked, select[name^="option"]')).forEach((option) => options.push(option.value));
          return options;
        }
        _updateDisableSelectors() {
          const selectedVariant = this.selectedVariant;
          if (!selectedVariant) {
            return;
          }
          const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination) => {
            let selectorType = selector.getAttribute("data-selector-type"), cssSelector = "";
            switch (selectorType) {
              case "color":
                cssSelector = `.color-swatch:nth-child(${valueIndex + 1})`;
                break;
              case "variant-image":
                cssSelector = `.variant-swatch:nth-child(${valueIndex + 1})`;
                break;
              case "block":
                cssSelector = `.block-swatch:nth-child(${valueIndex + 1})`;
                break;
              case "dropdown":
                cssSelector = `.combo-box__option-item:nth-child(${valueIndex + 1})`;
                break;
            }
            selector.querySelector(cssSelector).toggleAttribute("hidden", !hasAtLeastOneCombination);
            if (this.hideSoldOutVariants) {
              selector.querySelector(cssSelector).toggleAttribute("hidden", !available);
            } else {
              selector.querySelector(cssSelector).classList.toggle("is-disabled", !available);
            }
          };
          if (this.optionSelectors && this.optionSelectors[0]) {
            this.product["options"][0]["values"].forEach((value, valueIndex) => {
              const hasAtLeastOneCombination = this.product["variants"].some((variant) => variant["option1"] === value && variant), hasAvailableVariant = this.product["variants"].some((variant) => variant["option1"] === value && variant["available"]);
              applyClassToSelector(this.optionSelectors[0], valueIndex, hasAvailableVariant, hasAtLeastOneCombination);
              if (this.optionSelectors[1]) {
                this.product["options"][1]["values"].forEach((value2, valueIndex2) => {
                  const hasAtLeastOneCombination2 = this.product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant), hasAvailableVariant2 = this.product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant["available"]);
                  applyClassToSelector(this.optionSelectors[1], valueIndex2, hasAvailableVariant2, hasAtLeastOneCombination2);
                  if (this.optionSelectors[2]) {
                    this.product["options"][2]["values"].forEach((value3, valueIndex3) => {
                      const hasAtLeastOneCombination3 = this.product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant), hasAvailableVariant3 = this.product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant["available"]);
                      applyClassToSelector(this.optionSelectors[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3);
                    });
                  }
                });
              }
            });
          }
        }
      };
      window.customElements.define("product-variants", ProductVariants);
    }
    
    // js/custom-element/section/product-list/product-item.js
    if (!window.customElements.get("product-item")) {
      var ProductItem = class extends CustomHTMLElement {
        connectedCallback() {
          this.primaryImageList = Array.from(this.querySelectorAll(".product-item__primary-image"));
          this.delegate.on("change", ".product-item-meta__swatch-list .color-swatch__radio", this._onColorSwatchChanged.bind(this));
          this.delegate.on("mouseenter", ".product-item-meta__swatch-list .color-swatch__item", this._onColorSwatchHovered.bind(this), true);
        }
        async _onColorSwatchChanged(event, target) {
          Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
            let url;
            if (link.tagName === "A") {
              url = new URL(link.href);
            } else {
              url = new URL(link.getAttribute("href"), `https://${window.themeVariables.routes.host}`);
            }
            url.searchParams.set("variant", target.getAttribute("data-variant-id"));
            link.setAttribute("href", url.toString());
          });
          if (target.hasAttribute("data-variant-featured-media")) {
            const newImage = this.primaryImageList.find((image) => image.getAttribute("data-media-id") === target.getAttribute("data-variant-featured-media"));
            newImage.setAttribute("loading", "eager");
            const onimageLoaded = newImage.complete ? Promise.resolve() : new Promise((resolve) => newImage.onload = resolve);
            await onimageLoaded;
            newImage.removeAttribute("hidden");
            let properties = {};
            if (Array.from(newImage.parentElement.classList).some((item) => ["aspect-ratio--short", "aspect-ratio--tall", "aspect-ratio--square"].includes(item))) {
              properties = [
                { clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)", transform: "translate(calc(-50% - 20px), -50%)", zIndex: 1, offset: 0 },
                { clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)", transform: "translate(calc(-50% - 20px), -50%)", zIndex: 1, offset: 0.3 },
                { clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", transform: "translate(-50%, -50%)", zIndex: 1, offset: 1 }
              ];
            } else {
              properties = [
                { clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)", transform: "translateX(-20px)", zIndex: 1, offset: 0 },
                { clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)", transform: "translateX(-20px)", zIndex: 1, offset: 0.3 },
                { clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", transform: "translateX(0px)", zIndex: 1, offset: 1 }
              ];
            }
            await newImage.animate(properties, {
              duration: 500,
              easing: "ease-in-out"
            }).finished;
            this.primaryImageList.filter((image) => image.classList.contains("product-item__primary-image") && image !== newImage).forEach((image) => image.setAttribute("hidden", ""));
          }
        }
        _onColorSwatchHovered(event, target) {
          const input = target.previousElementSibling;
          if (input.hasAttribute("data-variant-featured-media")) {
            const newImage = this.primaryImageList.find((image) => image.getAttribute("data-media-id") === input.getAttribute("data-variant-featured-media"));
            newImage.setAttribute("loading", "eager");
          }
        }
      };
      window.customElements.define("product-item", ProductItem);
    }
    
    if (!window.customElements.get("model-media")) {
      var ModelMedia = class extends HTMLElement {
        constructor() {
          super();
          window.LibraryLoader.load("modelViewerUiStyles");
          window.Shopify.loadFeatures([
            {
              name: "shopify-xr",
              version: "1.0",
              onLoad: this._setupShopifyXr.bind(this)
            },
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: () => {
                this.modelUi = new window.Shopify.ModelViewerUI(this.firstElementChild, { focusOnPlay: false });
                const modelViewer = this.querySelector("model-viewer");
                modelViewer.addEventListener("shopify_model_viewer_ui_toggle_play", () => {
                  modelViewer.dispatchEvent(new CustomEvent("model:played", { bubbles: true }));
                });
                modelViewer.addEventListener("shopify_model_viewer_ui_toggle_pause", () => {
                  modelViewer.dispatchEvent(new CustomEvent("model:paused", { bubbles: true }));
                });
              }
            }
          ]);
        }
        disconnectedCallback() {
          var _a;
          (_a = this.modelUi) == null ? void 0 : _a.destroy();
        }
        play() {
          if (this.modelUi) {
            this.modelUi.play();
          }
        }
        pause() {
          if (this.modelUi) {
            this.modelUi.pause();
          }
        }
        async _setupShopifyXr() {
          if (!window.ShopifyXR) {
            document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this));
          } else {
            const product = await ProductLoader.load(this.getAttribute("product-handle"));
            const models = product["media"].filter((media) => media["media_type"] === "model");
            window.ShopifyXR.addModels(models);
            window.ShopifyXR.setupXRElements();
          }
        }
      };
      window.customElements.define("model-media", ModelMedia);
    }
    
    // js/custom-element/ui/combo-box.js
    if (!window.customElements.get("combo-box")) {
      const OpenableElement = window.customElements.get("openable-element");
      var ComboBox = class extends OpenableElement {
        connectedCallback() {
          super.connectedCallback();
          this.options = Array.from(this.querySelectorAll('[role="option"]'));
          this.delegate.on("click", '[role="option"]', this._onValueClicked.bind(this));
          this.delegate.on("keydown", '[role="listbox"]', this._onKeyDown.bind(this));
          this.delegate.on("change", "select", this._onValueChanged.bind(this));
          this.delegate.on("click", ".combo-box__overlay", () => this.open = false);
          if (this.hasAttribute("fit-toggle")) {
            const maxWidth = Math.max(...this.options.map((item) => item.clientWidth)), control = document.querySelector(`[aria-controls="${this.id}"]`);
            if (control) {
              control.style.setProperty("--largest-option-width", `${maxWidth + 2}px`);
            }
          }
        }
        get nativeSelect() {
          return this.querySelector("select");
        }
        set selectedValue(value) {
          this.options.forEach((option) => {
            option.setAttribute("aria-selected", option.getAttribute("value") === value ? "true" : "false");
          });
        }
        attributeChangedCallback(name, oldValue, newValue) {
          super.attributeChangedCallback(name, oldValue, newValue);
          switch (name) {
            case "open":
              if (this.open) {
                const boundingRect = this.getBoundingClientRect();
                this.classList.toggle("combo-box--top", boundingRect.top >= window.innerHeight / 2 * 1.5);
                setTimeout(() => this.focusTrap.activate(), 150);
              } else {
                this.focusTrap.deactivate();
                setTimeout(() => this.classList.remove("combo-box--top"), 200);
              }
              document.documentElement.classList.toggle("lock-mobile", this.open);
          }
        }
        _onValueClicked(event, target) {
          this.selectedValue = target.value;
          this.nativeSelect.value = target.value;
          this.nativeSelect.dispatchEvent(new Event("change", { bubbles: true }));
          this.open = false;
        }
        _onValueChanged(event, target) {
          Array.from(this.nativeSelect.options).forEach((option) => option.toggleAttribute("selected", target.value === option.value));
          this.selectedValue = target.value;
        }
        _onKeyDown(event) {
          var _a, _b;
          if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            event.preventDefault();
            if (event.key === "ArrowDown") {
              (_a = document.activeElement.nextElementSibling) == null ? void 0 : _a.focus();
            } else {
              (_b = document.activeElement.previousElementSibling) == null ? void 0 : _b.focus();
            }
          }
        }
      };
      window.customElements.define("combo-box", ComboBox);
    }
    
    // js/custom-element/section/product/store-pickup.js
    if (!window.customElements.get("store-pickup")) {
      var StorePickup = class extends HTMLElement {
        connectedCallback() {
          var _a;
          (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this));
        }
        _onVariantChanged(event) {
          if (!event.detail.variant) {
            this.innerHTML = "";
          } else {
            this._renderForVariant(event.detail.variant["id"]);
          }
        }
        async _renderForVariant(id) {
          const response = await fetch(`${window.themeVariables.routes.rootUrlWithoutSlash}/variants/${id}?section_id=store-availability`), div = document.createElement("div");
          div.innerHTML = await response.text();
          this.innerHTML = div.firstElementChild.innerHTML.trim();
        }
      };
      window.customElements.define("store-pickup", StorePickup);
    }
    
    // js/custom-element/behavior/scroll-shadow.js
    var template = `
      <style>
        :host {
          display: inline-block;
          contain: layout;
          position: relative;
        }
        
        :host([hidden]) {
          display: none;
        }
        
        s {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          pointer-events: none;
          background-image:
            var(--scroll-shadow-top, radial-gradient(farthest-side at 50% 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
            var(--scroll-shadow-bottom, radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0))),
            var(--scroll-shadow-left, radial-gradient(farthest-side at 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
            var(--scroll-shadow-right, radial-gradient(farthest-side at 100%, rgba(0,0,0,.2), rgba(0,0,0,0)));
          background-position: top, bottom, left, right;
          background-repeat: no-repeat;
          background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;
        }
      </style>
      <slot></slot>
      <s></s>
    `;
    var Updater = class {
      constructor(targetElement) {
        this.scheduleUpdate = window.throttle(() => this.update(targetElement, getComputedStyle(targetElement)));
        this.resizeObserver = new ResizeObserver(this.scheduleUpdate.bind(this));
      }
      start(element) {
        if (this.element) {
          this.stop();
        }
        if (element) {
          element.addEventListener("scroll", this.scheduleUpdate);
          this.resizeObserver.observe(element);
          this.element = element;
        }
      }
      stop() {
        if (!this.element) {
          return;
        }
        this.element.removeEventListener("scroll", this.scheduleUpdate);
        this.resizeObserver.unobserve(this.element);
        this.element = null;
      }
      update(targetElement, style) {
        if (!this.element) {
          return;
        }
        const maxSize = style.getPropertyValue("--scroll-shadow-size") ? parseInt(style.getPropertyValue("--scroll-shadow-size")) : 0;
        const scroll = {
          top: Math.max(this.element.scrollTop, 0),
          bottom: Math.max(this.element.scrollHeight - this.element.offsetHeight - this.element.scrollTop, 0),
          left: Math.max(this.element.scrollLeft, 0),
          right: Math.max(this.element.scrollWidth - this.element.offsetWidth - this.element.scrollLeft, 0)
        };
        requestAnimationFrame(() => {
          for (const position of ["top", "bottom", "left", "right"]) {
            targetElement.style.setProperty(`--${position}`, `${scroll[position] > maxSize ? maxSize : scroll[position]}px`);
          }
        });
      }
    };
    var ScrollShadow = class extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: "open" }).innerHTML = template;
        this.updater = new Updater(this.shadowRoot.lastElementChild);
      }
      connectedCallback() {
        this.shadowRoot.querySelector("slot").addEventListener("slotchange", () => this.start());
        this.start();
      }
      disconnectedCallback() {
        this.updater.stop();
      }
      start() {
        this.updater.start(this.firstElementChild);
      }
    };
    if ("ResizeObserver" in window && !window.customElements.get("scroll-shadow")) {
      window.customElements.define("scroll-shadow", ScrollShadow);
    }
  }
  if (window.criticalLoaded) { init() }
  else { document.addEventListener("critical-js:loaded", init); }
})();